import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faMoneyBill1,
  faCalendarAlt,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MyLikedVacancies = () => {
  const [likedVacancies, setLikedVacancies] = useState([]);
  const [visibleVacancies, setVisibleVacancies] = useState([]); // видимые элементы
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const { t } = useTranslation();

  const userData = JSON.parse(localStorage.getItem("user"));
  const userId = id || userData?.id;

  // Получение данных
  useEffect(() => {
    if (!userId) return;

    const fetchLiked = async () => {
      try {
        const response = await fetch(
            `/api/get_liked_vacancies.php?user_id=${userId}`
        );
        const data = await response.json();
        setLikedVacancies(data);
        setVisibleVacancies(data.slice(0, itemsPerPage));
      } catch (error) {
        console.error("Ошибка при загрузке лайкнутых вакансий:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLiked();
  }, [userId]);

  // При смене страницы обновляем видимые элементы
  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setVisibleVacancies(likedVacancies.slice(startIndex, endIndex));
  }, [currentPage, likedVacancies]);

  if (loading)
    return <p className="text-center py-10 text-gray-500">{t("loading")}...</p>;

  if (likedVacancies.length === 0)
    return (
      <p className="text-center py-10 text-gray-500">
        Դուք դեռ չեք ավելացրել ոչ մի հայտարարություն
      </p>
    );

  const totalPages = Math.ceil(likedVacancies.length / itemsPerPage);

  return (
    <section className="p-12 opacity-0 animate-[showtitle_1s_forwards]">
      <h1 className="text-4xl font-bold opacity-0 animate-[showtitle_1s_forwards] mb-12 text-white uppercase">
        {t("savevacancies")}
      </h1>

      <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5">
        {visibleVacancies.map((vacancy) => (
          <article
            key={vacancy.id}
            className="w-full pt-3 overflow-hidden flex-col relative flex justify-start gap-3 items-center rounded-lg shadow-lg bg-white"
          >
            <div className="w-full px-3 flex justify-start items-center gap-6">
              <img
                 className="w-[100px] h-[100px] object-contain rounded-xl border-[4px] border-white shadow-lg bg-gray-200"
                src={`/api/uploads/${vacancy.companyLogo}`}
                alt={vacancy.companyName || "Company Logo"}
              />
              <ul className="flex flex-col gap-1 items-start justify-center">
                <li>
                  <Link
                    to={`/vacancy/${vacancy.id}`}
                    className="text-xl text-[#006674] font-semibold hover:underline"
                  >
                    {vacancy.workname}
                  </Link>
                </li>
                <li className="text-gray-800 text-xl">{vacancy.companyName}</li>
                <li className="flex gap-2 items-center text-gray-600 text-md">
                  <FontAwesomeIcon icon={faLocationDot} />
                  {vacancy.workplace}
                </li>
                <li className="flex gap-2 text-md items-center text-gray-600">
                  <FontAwesomeIcon icon={faMoneyBill1} />
                  {vacancy.salary
                    ? `${vacancy.salary} ${vacancy.currency || ""}`
                    : "Չի նշված"}
                </li>
              </ul>
            </div>
            <div className="w-full mt-2 p-2 flex justify-between items-center bg-[#006674] text-white text-sm">
              <span>
                <FontAwesomeIcon className="mr-1" icon={faCalendarAlt} />
                {new Date(vacancy.created_at).toLocaleDateString()}
              </span>
              <Link to={`/vacancy/${vacancy.id}`} className="hover:underline">
                Տեսնել ավելին
              </Link>
            </div>
          </article>
        ))}
      </section>

      {/* Пагинация */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-3 mt-10">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
            className={`flex justify-center items-center rounded-full w-[40px] h-[40px] ${
              currentPage === 1
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-[#006674] text-white hover:bg-[#00525b]"
            }`}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </button>

          <span className="text-white">
            {currentPage} / {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
            className={`flex justify-center items-center rounded-full w-[40px] h-[40px] ${
              currentPage === totalPages
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-[#006674] text-white hover:bg-[#00525b]"
            }`}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </button>
        </div>
      )}
      
    </section>
  );
};

export default MyLikedVacancies;
